export const isSSR = () => typeof window === 'undefined';
export const isDev = () => process.env.NODE_ENV == 'development';
export const isProduction = () => process.env.DEPLOY_TARGET === 'production';
export const isProdDeploy = () => !!process.env.isProdDeploy;
